import React, { ReactNode } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import clsx from 'clsx'
import styles from './styles.module.scss'

interface ModalContainerProps {
  className?: string
  classNameHeader?: string
  children?: ReactNode
  rightHeaderContent?: ReactNode
  header?: string
  headerIcon?: ReactNode
  leftHeaderContent?: ReactNode
  onClose: () => void
}

const ModalContainer = React.forwardRef<HTMLDivElement, ModalContainerProps>(
  (
    {
      className,
      children,
      header = '',
      headerIcon,
      leftHeaderContent,
      onClose,
      rightHeaderContent,
      classNameHeader,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        tabIndex={-1}
        className={clsx(className, styles.container, 'd-flex flex-column is-model-open')}
      >
        <div
          className={clsx(
            'd-flex justify-content-between align-items-center',
            styles.header,
            classNameHeader
          )}
        >
          <div className="d-flex align-items-center">
            {header && <h3 className={styles.title}>{header}</h3>}
            {leftHeaderContent}
            {headerIcon && <div className={styles.header_icon}>{headerIcon}</div>}
          </div>

          <div className="d-flex align-items-center">
            {rightHeaderContent}
            <IconButton
              size="small"
              onClick={onClose}
              className={styles.btnClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        {children}
      </div>
    )
  }
)

ModalContainer.displayName = 'ModalContainer'

export default ModalContainer
